<template>
	<div>
		<Header  v-show="!$route.meta.hiddenHeader" />
		<!-- :key="$route.fullPath" 解决了路由前缀相同时跳转不刷新 -->
		<router-view :key="$route.fullPath"/>
		<Footer v-show="!$route.meta.hiddenFooter" />
	</div>
	
</template>
<script>
	import Header from "@/components/common/header/Header";
	import Footer from "@/components/common/footer/Footer";
	
	export default {
		name: "App",
		components:{Header, Footer}
		// components:{Header}
		// components:{Footer}
	}
</script>
<style>
/* 全局样式 */
.show-edit-icon {
	display: flex !important;
}
.hidden-menu-edit-icon {
	display: none !important;
}
/* 解决：el-select 在 ios 系统上点击两次才触发*/
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>